document.addEventListener('DOMContentLoaded', () => {
// 輪播 - 信LINE所託
  const lineSwiper = new Swiper('#lineSwiper', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 2500
    }
  });
  const lineButtons = document.querySelectorAll('.c-line-wrapper .l-slider-button');

  function updateButtons(activeIndex) {
    lineButtons.forEach((btn, i) => {
      btn.classList.toggle('active', i === activeIndex);
    });
  }

  lineSwiper.on('slideChange', () => {
    updateButtons(lineSwiper.realIndex);
  });
  lineButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const index = Number(btn.dataset.index);
      lineSwiper.slideToLoop(index);
      updateButtons(index);
    });
  });
  updateButtons(0);
  const lineWrapper = document.querySelector('.c-line-wrapper .l-slider-wrapper');
  lineWrapper.addEventListener('mouseenter', () => {
    lineSwiper.autoplay.stop();
  });
  lineWrapper.addEventListener('mouseleave', () => {
    lineSwiper.autoplay.start();
  });

// 雙層輪播 - 明細查詢
  const detailOuterSwiper = new Swiper('.c-detail-wrapper #outerSwiper', {
    slidesPerView: 1,
    loop: false,
    pagination: {
      el: '.c-detail-wrapper .c-outer-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.c-detail-wrapper .c-detail-swiper-next',
      prevEl: '.c-detail-wrapper .c-detail-swiper-prev'
    }
  });
  const detailInnerSwipers = document.querySelectorAll('.c-detail-wrapper .l-slider-wrapper__img');
  detailInnerSwipers.forEach(swiperEl => {
    const swiper = new Swiper(swiperEl, {
      effect: 'fade',
      loop: true,
      autoplay: {
        delay: 2500
      }
    });

    function updateButtons(index) {
      buttons.forEach(btn => btn.classList.remove('active'));
      buttons[index].classList.add('active');
    }

    const buttons = swiperEl.parentElement.querySelectorAll('.c-detail-wrapper .l-slider-button');
    swiper.on('slideChange', () => {
      updateButtons(swiper.realIndex);
    });
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const index = Number(btn.dataset.index);
        swiper.slideToLoop(index);
        updateButtons(index);
      });
    });
    updateButtons(0);
    const detailWrapper = document.querySelector('.c-detail-wrapper__content');
    detailWrapper.addEventListener('mouseenter', () => {
      swiper.autoplay.stop();
    });
    detailWrapper.addEventListener('mouseleave', () => {
      swiper.autoplay.start();
    });
  });
  document.querySelectorAll('.c-service-wrapper [data-bs-toggle="tab"]').forEach(tab => {
    tab.addEventListener('hide.bs.tab', e => {
      const prevTab = e.relatedTarget;
      if (!prevTab) {
        return;
      }
      const prevPaneId = prevTab.getAttribute('data-bs-target');
      const prevPane = document.querySelector(prevPaneId);
      if (!prevPane) {
        return;
      }
      prevPane.querySelectorAll('[data-aos]').forEach(el => {
        el.classList.remove('aos-animate');
      });
    });
    tab.addEventListener('shown.bs.tab', e => {
      const activePaneId = e.target.getAttribute('data-bs-target');
      const activePane = document.querySelector(activePaneId);
      if (!activePane) {
        return;
      }
      activePane.querySelectorAll('[data-aos]').forEach(el => {
        void el.offsetWidth;
        el.classList.add('aos-animate');
      });
    });
  });

  const digitVideoBtn = document.querySelector('#digit-video-btn');
  const itemIcon = digitVideoBtn?.querySelector('.c-item-icon');
  const digitVideoWrapper = digitVideoBtn?.parentElement.querySelector('#j-digit-video-wrapper');
  const digitVideo = digitVideoBtn?.parentElement.querySelector('#j-digit-video');

  if (digitVideoBtn && itemIcon && digitVideo) {
    itemIcon.addEventListener('click', () => {
      digitVideoBtn.style.display = 'none';
      digitVideoWrapper.style.display = 'block';
      digitVideo.play();
    });

    digitVideoWrapper.style.display = 'none';
  }
});
